module.exports = __webpack_public_path__ + "img/P31920580Xcamera.97c6731b.jpg";